"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getPaletteScaleMode: function() {
        return getPaletteScaleMode;
    },
    isAutoScaleOn: function() {
        return isAutoScaleOn;
    }
});
const _enums = require("../../enums");
const { AUTO, ADJUSTABLE } = _enums.AutoscaleMode;
function getPaletteScaleMode(nextBool) {
    return nextBool ? AUTO : ADJUSTABLE;
}
function isAutoScaleOn(nextMode) {
    return nextMode === AUTO;
}
